import * as XLSX from 'xlsx';

export const exportToExcel = (data, fileName, sheetName, columns) => {
    // Transform data based on columns
    const transformedData = data.map(item => {
        const row = {};
        columns.forEach(col => {
            row[col.label] = item[col.value];
        });
        return row;
    });

    const worksheet = XLSX.utils.json_to_sheet(transformedData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, sheetName || 'Sheet1');

    // Buffer to download
    XLSX.writeFile(workbook, `${fileName}.xlsx`);
};
